import { render } from "./BreadCrumb.vue?vue&type=template&id=1355e0b2&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"

import "./BreadCrumb.vue?vue&type=style&index=0&id=1355e0b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1355e0b2"

export default script